'use client';

export async function polishWorkspacePrompt(params: {
  prompt: string;
  imageUrls: string[];
}) {
  const response = await fetch('/api/ai/prompt-polish', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      prompt: params.prompt,
      images: params.imageUrls,
    }),
  });

  const body = (await response.json().catch(() => null)) as {
    prompt?: unknown;
    error?: unknown;
  } | null;
  if (!response.ok || typeof body?.prompt !== 'string') {
    throw new Error(
      typeof body?.error === 'string'
        ? body.error
        : 'Prompt polish failed. Please try again.'
    );
  }

  return body.prompt;
}
